import { AppBar } from "@/components/AppBar";
import { ContactFoot } from "@/components/shared/ContactFoot";
import { PhaseCard } from "@/components/service/PhaseCard";
import { Pricing } from "@/components/service/Pricing";
import { ServiceLoopDiagram } from "@/components/service/ServiceLoopDiagram";
import { TeamPlaceholder } from "@/components/service/TeamPlaceholder";
import { SERVICE_PHASES } from "@/data/service";
import { useContact } from "@/context/ContactContext";
import { createIntakeContext } from "@/lib/intakeContext";

export function ServicePage() {
  const { openIntakeContact } = useContact();
  const openIntake = () =>
    openIntakeContact(createIntakeContext({ source: "service" }));

  return (
    <>
      <AppBar title="服务介绍" showBack />
      <main className="pb-2">
        <section className="px-5 pb-6 pt-6">
          <p className="kicker mb-3.5">ASTRA · 留学管家服务</p>
          <h1 className="text-[30px] font-bold leading-tight tracking-tight text-ink-900">
            从你拿到offer,
            <br />
            到你毕业搬走那一天。
            <br />
            花小钱，办大事。
          </h1>
          <p className="mt-3.5 text-[13.5px] leading-[1.7] text-ink-600">
            四个环节,一位管家全程跟你。不转手、不换人、不踢皮球。
          </p>
        </section>

        <div className="px-4">
          <ServiceLoopDiagram phases={SERVICE_PHASES} />
        </div>

        <div className="flex flex-col gap-3 px-4 pb-5 pt-7">
          {SERVICE_PHASES.map((phase) => (
            <PhaseCard key={phase.n} phase={phase} />
          ))}
        </div>

        <Pricing />
        <TeamPlaceholder />
        <ContactFoot onContact={openIntake} />
      </main>
    </>
  );
}
